import { EmoticonFrownOutlineIcon } from './EmoticonFrownOutlineIcon';

/**
 * author: Google
 * id AE6333C6-8334-4F90-9230-6527F3A38C8A
 * name emoticon-frown-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-frown-outline.svg
 * tags
 * - Emoji 
 */
export const FaceFrownOutlineIcon = EmoticonFrownOutlineIcon;
export default FaceFrownOutlineIcon